import { AbstractComponent } from "appworks/components/abstract-component";
import { Components } from "appworks/components/components";
import { gameLayers } from "game-layers";
import { TGRInstantWinsComponent } from "./tgr-instant-wins";
import { TGRMatrixComponent } from "./tgr-matrix";

export class TGRReelDustComponent extends AbstractComponent {

    public init(): void {
        Components.get(TGRMatrixComponent).getTransition().onReelLand.add((reel: number) => this.onReelLand(reel));
    }

    protected onReelLand(reel: number): void {
        const dust = gameLayers.ReelDust.getAnimatedSprite(`dust_${reel}`);
        if (dust) {
            dust.visible = true;
            dust.gotoAndPlayOnce(0).then(() => dust.visible = false);
        }
    }
}

export const tgrInstantWinsComponent = new TGRInstantWinsComponent();
